import { Badge, Divider, Flex, VStack } from '@chakra-ui/react'

import { DetailField } from '../../../components/DetailField'
import { FormModal } from '../../../components/FormModal'
import { formatIsoDate, formatPhone } from '../../../helpers'
import { IExperimentalClassRowRaw } from '../../../services/ExperimentalClass/types'

interface IProps {
  isOpen: boolean
  onClose: () => void
  row: IExperimentalClassRowRaw | null
}

export function ResponsibleDetailsModal({ isOpen, onClose, row }: IProps) {
  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Ver detalhes" size="compact">
      {row && (
        // O espaçamento entre os campos é da pilha, não de um `mb` repetido em cada um.
        <VStack align="stretch" spacing={3}>
          <DetailField label="Status">
            <Badge colorScheme={row.attended ? 'green' : 'gray'} alignSelf="flex-start">
              {row.attended ? 'Compareceu' : 'Aguardando'}
            </Badge>
          </DetailField>

          <Flex gap={4}>
            <DetailField label="Data" value={formatIsoDate(row.class_date)} flex={1} />
            <DetailField label="Horário" value={row.class_time.replace(':', 'h')} flex={1} />
          </Flex>
          <Flex gap={4}>
            <DetailField label="Dia da semana" value={row.day_of_week} flex={1} />
            <DetailField label="Turma" value={row.turma} flex={1} />
          </Flex>
          <DetailField label="Curso" value={row.course_name} />
          <Flex gap={4}>
            <DetailField label="Professor" value={row.teacher_name} flex={1} />
            <DetailField label="Consultor" value={row.consultant_name} flex={1} />
          </Flex>

          <Divider />

          <DetailField label="Aluno" value={`${row.student_name} (${row.student_age} anos)`} />

          <Divider />

          <DetailField label="Nome do responsável" value={row.guardian_name} />
          <Flex gap={4}>
            <DetailField label="E-mail" value={row.guardian_email} flex={1} />
            <DetailField label="Telefone" value={formatPhone(row.guardian_phone)} flex={1} />
          </Flex>

          <Divider />

          <DetailField label="Observações" value={row.observations} />
        </VStack>
      )}
    </FormModal>
  )
}
